import { create } from "zustand";

interface FiltersHeightStore {
  height: number;
  setHeight: (height: number) => void;
}

export const useFiltersHeightStore = create<FiltersHeightStore>()((set) => ({
  height: 0,
  setHeight: (height) => set({ height })
}));
